import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import FontAwesomeIcon from '../Icon';
import './OpenContactLink.scss';

interface OpenContactLinkProps {
  userId: string;
  name: string;
  navOrigin?: any;
}

const OpenContactLink = ({ userId, name, navOrigin }: OpenContactLinkProps) => {
  const pathname: string = PATHS.CONTACTS_VIEW.replace(':id', userId);

  if (navOrigin) {
    const inAppLabel: string = `Open ${name}'s contact page`;

    return (
      <Link
        className="open-contact-link"
        to={{ pathname, state: { navOrigin } }}
        title={inAppLabel}
        aria-label={inAppLabel}
      >
        <FontAwesomeIcon glyph="external-link" weight="light" />
      </Link>
    );
  }

  const newTabLabel: string = `Open ${name}'s contact page in a new tab`;

  return (
    <a
      className="open-contact-link"
      href={pathname}
      target="_blank"
      rel="noopener noreferrer"
      title={newTabLabel}
      aria-label={newTabLabel}
    >
      <FontAwesomeIcon glyph="external-link" weight="light" />
    </a>
  );
};

export default OpenContactLink;